import { reactive } from "vue";

const STORAGE_KEY = "onboarding-video-time";

interface VideoState {
    videoId: string | null;
    stepTitle: string | null;
    posterUrl: string | null;
    isPlaying: boolean;
}

const onboardingVideo = reactive<VideoState>({
    videoId: null,
    stepTitle: null,
    posterUrl: null,
    isPlaying: false,
});

export function useOnboardingVideo() {
    function playVideo(videoId: string, stepTitle: string, posterUrl: string | null) {
        onboardingVideo.videoId = videoId;
        onboardingVideo.stepTitle = stepTitle;
        onboardingVideo.posterUrl = posterUrl;
        onboardingVideo.isPlaying = true;
    }

    function dismissVideo() {
        onboardingVideo.isPlaying = false;
        onboardingVideo.videoId = null;
        onboardingVideo.stepTitle = null;
        onboardingVideo.posterUrl = null;
        localStorage.removeItem(STORAGE_KEY);
    }

    function savePlaybackTime(videoId: string, seconds: number) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({ videoId, seconds }));
    }

    function getPlaybackTime(videoId: string): number {
        try {
            const raw = localStorage.getItem(STORAGE_KEY);
            if (!raw) return 0;
            const parsed = JSON.parse(raw);
            return parsed.videoId === videoId ? Math.floor(parsed.seconds) : 0;
        } catch {
            return 0;
        }
    }

    return {
        onboardingVideo,
        playVideo,
        dismissVideo,
        savePlaybackTime,
        getPlaybackTime,
    };
}
